// extracted by mini-css-extract-plugin
export default {"wrap":"qw-z","fullWidth":"rw-z","searchPlacement":"sw-z","items":"tw-z","featureCss":"uw-z","disabled":"vw-z","imgCss":"ww-z"};